export default __webpack_public_path__ + "static/reviewer-image-2-6c728d289338d3d91a63f33e4cbc0f9a.png";